import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import moment from 'moment'
import 'view-design/dist/styles/iview.css';
import VueQriously from 'vue-qriously'
import SlideVerify from 'vue-monoplasty-slide-verify';
import global_ from './Global.js'
// import rewriteLog from './libs/index'
function rewriteLog (){
    console.log = (function (log) {
      return function() {}
        // return process.env.NODE_ENV == 'development'? log : function() {}
    }(console.log))
}
Vue.prototype.GLOBAL = global_
// rewriteLog ()
Vue.use(SlideVerify)
Vue.use(VueQriously)
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(ViewUI);
Vue.filter('time', function (value) {
  return moment(value*1000).format("YYYY-MM-DD")
})
// rewriteLog()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
